module.exports = __webpack_public_path__ + "media/images/number_10_red-8b8fe51fcf5c86838d56420e67c8ba62.png";